import { render, staticRenderFns } from "./SubHeaders.vue?vue&type=template&id=6e97b553&"
import script from "./SubHeaders.vue?vue&type=script&lang=js&"
export * from "./SubHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports